import axios from "axios";
import Spinner from "../../Spinner/Spinner";
import React, { useEffect, useState } from "react";
import { apiCall_domain } from "../../api";
import CategoriesList from "./CategoriesList";
import { Box, FormControl, MenuItem, Pagination, Select } from "@mui/material";
import CarFiltering from "./carFiltering";
import ProductMainCard from "../../global/ProductMainCard";
import { createGlobalStyle } from "styled-components";

const Categories = (props) => {
  const [selectedSort, setSelectedSort] = useState();
  const [paginationData, setPaginationData] = useState();
  const [defaultPriceRange, setDefaultPriceRange] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filters, setFilters] = useState();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [features, setFeatures] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(true);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [priceSort, setPriceSort] = useState([
    { label: "هیچکدام", value: 6 },
    { label: "ارزان ترین", value: 2 },
    { label: "گران ترین", value: 1 },
    { label: "جدید ترین", value: 4 },
    { label: "پر فروش ترین", value: 5 },
    { label: "پر بازدید ترین", value: 3 },
  ]);
  const [appliedFilters, setAppliedFilters] = useState({ stock: false });
  const [subCategoryId, setSubCategoryId] = useState();

  const Headers = {
    Authorization: localStorage.getItem("Api_key"),
    "content-type": "application/json",
  };

  let carData;

  if (localStorage.getItem("data")) {
    carData = JSON.parse(localStorage.getItem("data"));
  }
  const defaultData = {
    page: 1,
    price_from: 0,
    price_to: 999999999,
    orderBy: 6,
    stock: 0,
    car_type_id: carData?.type ? +carData.type : "",
    car_id: carData?.car.id ? carData.car.id : "",
    car_brand_id: carData?.brand.id ? carData.brand.id : "",
  };
  const params = new URLSearchParams(props.propsSearch);

  useEffect(() => {
    setSubCategoryId(params.get("subCategoryId"));

    const getCategories = axios.get(`${apiCall_domain}/customer/categories`, {
      headers: Headers,
    });
    const getAllProducts = axios.post(
      `${apiCall_domain}/customer/categories/${
        subCategoryId ? subCategoryId : props.categoryId
      }/products?vendor_id=${props.vendorId}&page=1`,
      defaultData,
      { headers: Headers }
    );

    axios.all([getCategories, getAllProducts]).then(
      axios.spread((...res) => {
        const categories = res[0];
        setCategories(categories.data.data);
        const products = res[1];
        setPaginationData(products.data.products.meta);
        setProducts(products.data.products.data);
        setAppliedFilters({
          price_from: products.data.options.price_range.min,
          price_to: products.data.options.price_range.max,
        });
        setFilters(products.data.options.filters);
        setDefaultPriceRange([
          products.data.options.price_range.min,
          products.data.options.price_range.max,
        ]);
        setLoading(false);
        setCategoryLoading(false);
      })
    );
  }, []);
  const getProducts = (page, isGet) => {
    setCategoryLoading(true);
    const getData = {
      features: features,
      page: page,
      stock: appliedFilters.stock ? 1 : 0,
      is_limited: appliedFilters.is_limited ? appliedFilters.is_limited : 0,
      price_from: appliedFilters.price_from,
      price_to: appliedFilters.price_to,
      orderBy: selectedSort ? selectedSort.value : 6,
      car_type_id: carData?.type ? +carData.type : "",
      car_id: carData?.car.id ? carData.car.id : "",
      car_brand_id: carData?.brand.id ? carData.brand.id : "",
    };
    axios
      .post(
        `${apiCall_domain}/customer/categories/${
          subCategoryId ? subCategoryId : props.categoryId
        }/products?vendor_id=${props.vendorId}&page=1`,
        isGet ? getData : defaultData,
        { headers: Headers }
      )
      .then((res) => {
        setAppliedFilters({
          stock: appliedFilters.stock,
          price_from: res.data.options.price_range.min,
          price_to: res.data.options.price_range.max,
          orderBy: selectedSort?.value,
        });
        setProducts(res.data.products.data);
        setCategoryLoading(false);
        setFilters(res.data.options.filters);
        setPaginationData(res.data.products.meta);
        setDefaultPriceRange([
          res.data.options.price_range.min,
          res.data.options.price_range.max,
        ]);
      });
    if (!isGet) {
      setSelectedSort();
    }
  };

  useEffect(() => {
    getProducts(1, false);
  }, [subCategoryId, props.categoryId]);

  useEffect(() => {
    if (selectedSort) {
      getProducts(1, true);
    }
  }, [selectedSort]);

  const handleStock = (e, newValue) => {
    setAppliedFilters({
      ...appliedFilters,
      stock: newValue,
    });
  };

  const changePriceRange = (e, newValue) => {
    setAppliedFilters({
      ...appliedFilters,
      price_from: newValue[0],
      price_to: newValue[1],
    });
  };

  const handleModal = () => {
    setShowFilterModal(!showFilterModal);
    if (showFilterModal) {
      setAppliedFilters({
        price_from: defaultPriceRange[0],
        price_to: defaultPriceRange[1],
      });
    }
    window.scrollTo(0, 0);
  };

  const handleOrderBy = (e) => {
    setSelectedSort(e.target.value);
  };

  const applyFilter = () => {
    getProducts(1, true);
    handleModal();
    window.scrollTo(0, 0);
  };

  const clearFilter = () => {
    setFeatures([]);
    getProducts(1, false);
    setAppliedFilters({
      price_from: defaultPriceRange[0],
      price_to: defaultPriceRange[1],
    });
    setShowFilterModal(false);
    window.scrollTo(0, 0);
  };

  const addFilter = (id, value) => {
    let state = [...features];
    const selectedFeature = state.find((feature) => +feature.id === id);
    const selectedFeatureDelete = state.findIndex(
      (feature) => +feature.id === id
    );
    if (selectedFeature && value === "") {
      state.splice(selectedFeatureDelete, 1);
    } else if (selectedFeature) {
      selectedFeature.value = value;
      state[selectedFeatureDelete] = selectedFeature;
    } else if (value !== "") {
      state.push({ id, value });
    }

    setFeatures(state);
  };
  const checkForNumric = (id, value) => {
    const numRegex = /^[1-9][\.\d]*(,\d+)?$/;
    if (numRegex.test(value)) {
      addFilter(id, value);
    }
  };

  const checkForText = (id, value) => {
    addFilter(id, value);
  };

  const handlePagination = (event, page) => {
    getProducts(page, true);
  };

  const GlobalStyles = createGlobalStyle`body{
      background: ${!showFilterModal ? "#E5E5E5" : "#fff"};
    }`;
  const currentCategory = categories.find(
    (category) => category.id == props.categoryId
  );
  return loading ? (
    <Spinner />
  ) : (
    <>
      <GlobalStyles />

      <div className='category vendorCategory'>
          <CategoriesList
            vendorId={props.vendorId}
          categories={categories}
          selectedCategory={parseInt(props.categoryId)}
          selectedSubCategory={subCategoryId}
        />
        {categoryLoading ? (
          <Spinner />
        ) : (
          <>
            <div className='categoryFilter'>
              <div className='filterBox'>
                <i className='icon-filters' />
                <span
                  onClick={() => {
                    handleModal();
                  }}>
                  فیلتر بندی
                </span>
                <div
                  className={`carFilterModal ${
                    showFilterModal ? "showFilterModal" : null
                  }`}>
                  <CarFiltering
                    addFilter={addFilter}
                    checkForText={checkForText}
                    checkForNumric={checkForNumric}
                    handleModal={handleModal}
                    filter={filters}
                    price={[appliedFilters.price_from, appliedFilters.price_to]}
                    changePriceRange={changePriceRange}
                    handleStock={handleStock}
                    stock={appliedFilters.stock}
                    applyFilter={applyFilter}
                    clearFilter={clearFilter}
                    features={features}
                    defaultPrice={defaultPriceRange}
                  />
                </div>
              </div>
              <div className='priceBox'>
                <i className='icon-order' />

                <Box>
                  <FormControl>
                    <Select
                      onChange={handleOrderBy}
                      displayEmpty
                      value={selectedSort}>
                      <MenuItem disabled> مرتب سازی</MenuItem>
                      {priceSort.map((range, index) => (
                        <MenuItem value={range} key={index}>
                          {range.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </div>
            </div>
            <div
              className={` categoryProductSection ${
                products.length ? " " : "noStockCategory"
              }`}>
              {!showFilterModal ? (
                products.length ? (
                  products.map((item, index) => (
                    <ProductMainCard
                      data={item}
                      deadline={item.deadline}
                      countDown={false}
                      featuresStat={true}
                      features={item.features}
                      key={index}
                    />
                  ))
                ) : (
                  <div className='noProductSection'>
                    <span className='noStock'>هیج کالایی وجود ندارد</span>
                  </div>
                )
              ) : null}
            </div>
            {paginationData.last_page > 1 && (
              <div className='pagination'>
                <Pagination
                  count={paginationData.last_page}
                  onChange={handlePagination}
                  page={paginationData.current_page}
                />
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Categories;
